import * as grid from '@helpcenter/styles/src/grid';
import * as transitions from '@helpcenter/styles/src/transitions';

export const EXPAND_TIME_MS = transitions.speedMs.medium;
export const SIDEBAR_WIDTH_LARGE_MULTIPLIER: number = 50;
export const SIDEBAR_WIDTH_LARGE_VIEWPORT = grid.multiple(SIDEBAR_WIDTH_LARGE_MULTIPLIER).px;
export const SIDEBAR_HEIGHT_SMALL_VIEWPORT = '40vh';
export const SIDEBAR_FULL_HEIGHT_SMALL_VIEWPORT = '100vh';
export const TAG_BUTTON_HEIGHT = grid.unitless * 5;
